export enum ApplicationSuggestionSelectedEventType {
  TextSuggestionSelected = 1,
  CategorySuggestionSelected,
  AllPromoSuggestionSelected,
  PromoSuggestionSelected,
  HistorySuggestionSelected
}
